import { Buffer } from 'buffer';

export default Buffer;
export { Buffer };
